export default function(Mousetrap) {
    let _originalStopCallback = Mousetrap.prototype.stopCallback

    Mousetrap.prototype.stopCallback = function(e, element, combo) {
        let self = this

        if (self.paused) {
            return true
        }

        return _originalStopCallback.call(self, e, element, combo)
    }

    Mousetrap.prototype.pause = function() {
        let self = this
        self.paused = true
    }

    Mousetrap.prototype.unpause = function() {
        let self = this
        self.paused = false
    }

    Mousetrap.init()
    
    return Mousetrap
}